import { useEffect } from 'react'
import { addPageAction } from '@mc/monitoring'

// JAR-2890: connect-src ships Content-Security-Policy-Report-Only, so
// violations surface only as browser events. Forward them to New Relic so the
// allowlist can be closed from real traffic before the directive is enforced.

// Repeat beacons to one blocked origin would otherwise flood New Relic.
const MAX_REPORTS_PER_PAGE = 20

const toOrigin = (blockedURI: string) => {
  try {
    return new URL(blockedURI).origin
  } catch {
    return blockedURI
  }
}

export const CspViolationReporter = () => {
  useEffect(() => {
    const reported = new Set<string>()

    const onViolation = (event: SecurityPolicyViolationEvent) => {
      const directive = event.effectiveDirective || event.violatedDirective
      if (!directive.startsWith('connect-src')) return

      const blockedOrigin = toOrigin(event.blockedURI)
      if (reported.has(blockedOrigin)) return
      if (reported.size >= MAX_REPORTS_PER_PAGE) return
      reported.add(blockedOrigin)

      addPageAction('csp_violation', {
        blockedOrigin,
        directive,
        disposition: event.disposition,
        documentURI: event.documentURI,
      })
    }

    document.addEventListener('securitypolicyviolation', onViolation)
    return () =>
      document.removeEventListener('securitypolicyviolation', onViolation)
  }, [])

  return null
}
